import React from 'react';
import { useDispatch } from 'react-redux';
import { appointmentActions } from 'store';
import { CustomizedSwitch, DateRowStartEnd, ToolInfo } from 'components';
import { PermissionList, RolePermission } from 'utils';
import { scheduleModalsStyle } from '../styles';
import { getDynamicTitle } from '../constants';
import { modalsStyle } from '../../../../../components/modal/styles';
import { SERVICE } from '../../../constants';

export const ModalHeader = ({ modalDate, type, createMultiple, setMultipleAppts, apptDates, setInputs, inputs }) => {
    const title = getDynamicTitle('TITLE', modalDate, type);
    const classes = scheduleModalsStyle();
    const global = modalsStyle();
    const dispatch = useDispatch();

    return (
        <>
            <div style={{ marginBottom: 24 }}>
                <div className="space-between">
                    <div className="flex-align-center" style={{ gap: 8 }}>
                        <p className={global.availableScheduleTitle}>{title}</p>

                        {(type === SERVICE && RolePermission([PermissionList.APPT_SUPERVISION_CREATE.code])) &&
                        <div className="switcher-style">
                            <p>Supervision</p>
                            <CustomizedSwitch
                                checked={inputs?.supervision}
                                handleClick={() => {
                                    setInputs((prev) => ({
                                        ...prev,
                                        supervision: !prev?.supervision,
                                        // Clear supervisee when turning supervision OFF
                                        supervisee: prev?.supervision ? null : prev?.supervisee,
                                    }));
                                }}
                            />
                        </div>
                        }

                        {apptDates && createMultiple && (
                            <p className={classes.apptTemplateDates}>
                                <DateRowStartEnd format={'MM/DD/YYYY'} start={apptDates?.startDate}
                                                 end={apptDates?.endDate} />
                            </p>
                        )}
                    </div>

                    {!modalDate && RolePermission([PermissionList.APPT_RECURE?.code]) && (
                        <div className={classes.signatureStyle}>
                            <ToolInfo
                                background={'transparent'}
                                text={'This action will create multiple appoiments that will become part of a series.'}
                            />
                            <p>Create Multiple</p>
                            <CustomizedSwitch checked={createMultiple} handleClick={setMultipleAppts} />
                        </div>
                    )}

                    {modalDate?.template && (
                        <div className={classes.signatureStyle}>
                            <p>Edit Group</p>
                            <CustomizedSwitch
                                checked={createMultiple}
                                handleClick={() => {
                                    setMultipleAppts();
                                    if (!createMultiple) {
                                        dispatch(appointmentActions.getAppointmentDates(modalDate?.template));
                                    } else {
                                        dispatch(appointmentActions.removeAppointmentDates());
                                    }
                                }}
                            />
                        </div>
                    )}
                </div>

                {modalDate?.template && !createMultiple && (
                    <div className="space-between" style={{ marginTop: 24 }}>
                        <div className={classes.multipleServiceNote}>
                            <ToolInfo noTool={true} />
                            <p>
                                Editing this appointment will <b>disconnect</b> it from the <b>group series.</b>
                                If you want to make changes to the entire series, please use the <b>'Edit Group'</b> action.
                            </p>
                        </div>
                    </div>
                )}


            </div>
        </>
    );
};
